import * as React from "react";
import MyChartDataTile from "../dashboard/MyChartDataTile";
import * as Tools from "../../helpers/Tools";
import { logUI } from "../../api/andyliticsApi";

const MyChartWrapper = (props) => {
    logUI("MBHWeb.UI.MyChartWrapper.ComponentDidMount", new Date(), Tools.getURLPath());

    const serverData = props.serverData;
    //debugger;
    return (
        <div className="container-fluid body-content">
            <div className="row">
                <div className="col-12 maxWidth-content">
                    <MyChartDataTile byroute="true" navigation="hide" onObserved={(data)=>{}}/>
                </div>
            </div>
        </div>
    );
};

export default MyChartWrapper;
